/**
 *  各组件模块 baseApi 使用
 * */
export const baseApis = {
  data() {
    return {
      baseApi: ''   // api网关（上传）
    }
  },
  created() {
    let locationHost = window.location.host
    if (locationHost.includes('localhost') || locationHost.includes('80')) {
      this.baseApi = process.env.BASE_API;   // api网关（上传）
    } else {
      if (window.location.href.includes('https')) {
        this.baseApi = "https://" + locationHost
      } else this.baseApi = "http://" + locationHost
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/baseApiMixin.js